<ng-content>
  <div class="chl-header-coins">
    @for (coin of coins(); track $index) {
      @if (coin.price; as price) {
        <a class="chl-header-coins-item" [href]="coin.link" target="_blank" rel="nofollow">
          <img class="chl-header-coins-item__img" [src]="coin.img" [alt]="coin.name">
          <div class="chl-header-coins-item__price">
            {{ price | currency: 'USD' : '$' : '1.2-2' : 'en-US' }}
          </div>
        </a>
      }
    }
  </div>

  <a class="chl-header-logo" (click)="reload()" href="/">
    <img class="chl-header-logo__img" src="assets/img/logos/cheelee-logo-mark-color.svg" alt="Chelee" />
  </a>

  <div class="chl-header-actions">
    <div class="chl-header-actions-lang" (click)="switchLanguage()">
      {{ currentLang() === LanguageLocales.RU ? 'ENG' : 'РУС' }}
    </div>

    <div class="chl-header-actions-item" (click)="openGetAppDialog()">
      <span>{{ 'actions:download' | i18nextEager }}</span>
      <svg class="chl-header-actions-item__icon chl-header-actions-item__icon--apple">
        <use xlink:href="assets/icons/ui-kit-icons.sprite.svg#apple-icon"></use>
      </svg>
      <svg class="chl-header-actions-item__icon">
        <use xlink:href="assets/icons/ui-kit-icons.sprite.svg#google-play-icon"></use>
      </svg>
    </div>
  </div>
</ng-content>
